import type { ReactNode } from "react";
import FocusLock from "react-focus-lock";
import { Box } from "~/components/Box/Box";

export function VoucherCodeDialog(props: { children: ReactNode }) {
  return (
    <FocusLock group="voucher-code">
      <Box
        display="flex"
        position="fixed"
        width="full"
        height="full"
        alignItems="center"
        justifyContent="center"
        userSelect="none"
        flexDirection="column"
        style={{
          background: "rgba(0, 0, 0, 0.5)",
          left: 0,
          top: 0,
          zIndex: 5,
        }}
      >
        <Box
          style={{ maxWidth: 425 }}
          background="jets-beige"
          padding={"5"}
          margin={"5"}
          borderRadius={"standard"}
        >
          {props.children}
        </Box>
      </Box>
    </FocusLock>
  );
}
